// extracted by mini-css-extract-plugin
module.exports = {"Experiments":"member-operations__Experiments__Experiments","Heading":"member-operations__Experiments__Heading","ExperimentName":"member-operations__Experiments__ExperimentName"};